module.exports = __webpack_public_path__ + "static/media/empty-inbox.svg";